import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Cuándo recibo el ebook?',
    answer: 'Inmediatamente después del pago recibís un correo con el enlace de descarga. Acceso al instante.'
  }, {
    question: '¿El acceso es para siempre?',
    answer: 'Sí. Una vez descargado, el ebook es tuyo para siempre. Sin suscripciones ni vencimientos.'
  }, {
    question: '¿Necesito hacer una dieta estricta?',
    answer: 'No. La guía está pensada para hacer cambios simples y sostenibles, no para restringirte ni pasar hambre.'
  }, {
    question: '¿Cuándo voy a ver resultados?',
    answer: 'Muchas mujeres notan los primeros cambios en los primeros 3 a 7 días. Los resultados más profundos se consolidan en el plan de 30 días.'
  }, {
    question: '¿Funciona si ya probé muchas dietas y nada me funcionó?',
    answer: 'Sí. Justamente está pensada para eso. Si comés bien y aun así te hinchás, esta guía trabaja la causa real, no solo los síntomas.'
  }, {
    question: '¿Qué tan difíciles son las recetas?',
    answer: 'Son simples, con ingredientes comunes y fáciles de conseguir. No necesitás ser cocinera ni tener tiempo extra.'
  }, {
    question: '¿Sirve aunque no tenga muchos síntomas digestivos?',
    answer: 'Sí. La inflamación abdominal puede tener múltiples causas. La guía te ayuda a identificar cuáles aplican a tu caso y cómo trabajarlas.'
  }, {
    question: '¿Es físico?',
    answer: 'No, es 100% digital con descarga inmediata.'
  }];
  return <section className="w-full bg-white py-16 px-4 md:px-8" data-id="element-54">
      <div className="max-w-2xl mx-auto" data-id="element-55">
        <motion.div initial={{
        opacity: 0,
        y: 25
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-56">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif text-text-dark" data-id="element-57">
            ❓ Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-3" data-id="element-58">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05
        }} className="bg-bg-soft rounded-xl overflow-hidden border border-secondary-light/20" data-id="element-59">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 text-left hover:bg-bg-mint/50 transition-colors duration-200" data-id="element-60">
                <span className="font-semibold text-text-dark pr-4 text-sm" data-id="element-61">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} data-id="element-62">
                  <ChevronDownIcon className="w-5 h-5 text-accent flex-shrink-0" data-id="element-63" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-64">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-65">
                    <div className="px-5 pb-5 text-primary-mid text-sm leading-relaxed" data-id="element-66">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}